import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { apiBaseUrl } from "@/api/service";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-company",
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      time: [],
      searchForm: {
        page: 1,
        count: 20,
        id: "",
        status: '',
        start_date: '',
        end_date: ''
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数
      importLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.page = 1;
                _this2.searchForm.count = 20;
              }
              if (_this2.time.length > 0) {
                _this2.searchForm.start_date = _this2.time[0];
                _this2.searchForm.end_date = _this2.time[1];
              } else {
                _this2.searchForm.start_date = '';
                _this2.searchForm.end_date = '';
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getAssistList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.total;
              _this2.tableLoading = false;
              _this2.getUserListByIds(_this2.tableData, "inviter_user_id", "invitee_user_id");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.$refs.uploader.clearFiles();
      } else {
        this.$message.error(res.msg);
      }
    },
    uploadError: function uploadError(err, file, fileList) {
      this.importLoading = false;
      this.$refs.uploader.clearFiles();
    },
    uploadProgress: function uploadProgress(event, file, fileList) {
      // console.log(event, file, fileList)
    },
    uploadChange: function uploadChange(file, fileList) {
      if (file.response && file.response.code == 200) {
        this.importLoading = false;
        this.$message.success(file.response.msg);
        this.pageChange(1);
      } else {
        this.importLoading = true;
      }
    }
  }
};